// extracted by mini-css-extract-plugin
export default {"btn_group":"ModalButtonGroup_btn_group__WGTvW","btn":"ModalButtonGroup_btn__Rv6YY","active":"ModalButtonGroup_active__SK5Gm"};